import { render, staticRenderFns } from "./fencheng.vue?vue&type=template&id=9d1c7dfc&scoped=true"
import script from "./fencheng.vue?vue&type=script&lang=js"
export * from "./fencheng.vue?vue&type=script&lang=js"
import style0 from "./fencheng.vue?vue&type=style&index=0&id=9d1c7dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1c7dfc",
  null
  
)

export default component.exports